import { Link } from "react-router-dom";

const Logo = ({ size = "default", showLLC = true }) => {
  const sizes = {
    small: { mark: "h-6 w-6", text: "text-sm", sub: "text-[9px]" },
    default: { mark: "h-9 w-9", text: "text-base", sub: "text-[10px]" },
    large: { mark: "h-12 w-12", text: "text-xl", sub: "text-xs" },
  };
  const s = sizes[size] || sizes.default;

  return (
    <Link
      to="/"
      data-testid="site-logo"
      className="flex items-center gap-3 group"
      aria-label="ArStudio Solutions LLC — Home"
    >
      <div
        className={`${s.mark} flex-shrink-0 relative flex items-center justify-center border border-white/30 group-hover:border-white transition-colors duration-300`}
      >
        <span
          className="font-display font-extrabold text-white leading-none"
          style={{ fontSize: "0.72em" }}
        >
          AR
        </span>
        <span className="absolute -top-[1px] -right-[1px] h-1 w-1 bg-[#FF3B30]" />
      </div>
      <div className="flex flex-col leading-none">
        <span
          className={`font-display font-extrabold tracking-tight text-white ${s.text}`}
        >
          ArStudio<span className="text-[#FF3B30]">.</span>
        </span>
        {showLLC && (
          <span
            className={`font-mono ${s.sub} text-white/50 tracking-[0.25em] mt-1`}
          >
            SOLUTIONS · LLC
          </span>
        )}
      </div>
    </Link>
  );
};

export default Logo;
